import React, { useState, useEffect, useMemo } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Sidebar from './Sidebar';
import Header from './Header';
import { getPageMeta } from '../config/pageMeta';

/** Fare tekerleği ile kaydırmayı koruyup scrollbar çubuğunu gizlemek için (WebKit / Firefox). */
const mainNoScrollbarTrim =
  '[scrollbar-width:none] [-ms-overflow-style:none] [&::-webkit-scrollbar]:hidden';
const Layout = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const location = useLocation();
  const pageMeta = useMemo(() => getPageMeta(location.pathname), [location.pathname]);
  const isCheckCreditActivityReportRoute = location.pathname.includes('/reports/check-credit-activity');

  useEffect(() => {
    const baseTitle = document.documentElement.dataset.appName || 'ERP';
    const title = pageMeta?.title ? `${pageMeta.title} | ${baseTitle}` : baseTitle;
    document.title = title;
  }, [pageMeta]);

  return (
    <div className="flex h-screen bg-gray-50 dark:bg-gray-900">
      {/* Sidebar */}
      <Sidebar open={sidebarOpen} setOpen={setSidebarOpen} />
      
      {/* Main content */}
      <div className="flex min-h-0 flex-1 flex-col overflow-hidden">
        {/* Header */}
        <Header onMenuClick={() => setSidebarOpen(true)} />
        
        {/* Page content */}
        <main
          className={`flex min-h-0 flex-1 flex-col overflow-x-hidden overflow-y-auto bg-gray-50 p-4 dark:bg-gray-900 ${
            isCheckCreditActivityReportRoute ? mainNoScrollbarTrim : ''
          }`}
        >
          <div
            className={`mx-auto w-full max-w-[110rem] ${
              isCheckCreditActivityReportRoute ? 'flex min-h-0 flex-1 flex-col' : ''
            }`}
          >
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  );
};

export default Layout;
